import { render, staticRenderFns } from "./EnglishProfileReplaceConfirmDialog.vue?vue&type=template&id=e346be6c"
import script from "./EnglishProfileReplaceConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishProfileReplaceConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishProfileReplaceConfirmDialog.vue?vue&type=style&index=0&id=e346be6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports